import { gql } from '@apollo/client';

export const UserConsentQuery = gql`
  query UserConsentQuery {
    getUserConsent {
      ok
      error
      isUserConsent
    }
  }
`;
